import WebApp from '@twa-dev/sdk';

import { getOpeningMethod } from '@/shared/helpers/environment/get-opening-method';
import { type UseWsReturnType } from '@/shared/hooks/use-ws';
import { type StartAppArgs } from '@/shared/store/tg-store/types';

import { getDeviceInfo } from '../../../helpers/environment/get-device-info';
import {
  type AnalyticsOptions,
  AnalyticsService,
  type EventEnrichment,
} from '../analytics-service';

export const createAnalyticsService = (
  startAppArgs: StartAppArgs,
  startAppRaw: string | undefined,
  ws: UseWsReturnType
) => {
  const telegram_id = WebApp?.initDataUnsafe?.user?.id ?? startAppArgs?.telegram_id;
  const tg_api_version = WebApp?.version;
  const is_premium = Boolean(WebApp?.initDataUnsafe?.user?.is_premium);
  const tg_platform = WebApp?.platform;

  const opening_method = getOpeningMethod();
  const deviceInfo = getDeviceInfo(WebApp.platform);

  const options: AnalyticsOptions = {
    predefinedValues: {
      user_properties: {
        telegram_id,
        tg_platform,
        tg_api_version,
        is_premium,
        ...deviceInfo,
      },
      event_properties: {
        event_source: 'front',
        opening_method,
        ...(startAppRaw && { startapp: startAppRaw }),
        ...(startAppArgs?.src && { source: startAppArgs?.src }),
      },
    },
    enrichEventData: startAppArgs?.enrich_event ?? ({} as EventEnrichment),
    ws,
  };

  const service = new AnalyticsService(options);

  return service;
};
